/**
 * Centralized Supabase client configuration
 * Single instance to reduce bundle size and improve performance
 */
import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_KEY } from "../config";

// Create a single instance of the Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export default supabase;
